ScrollOut({
    targets: "[data-scroll]",
    once: true
});

var swiper = new Swiper(".mySwiperReview", {
slidesPerView: 3,
spaceBetween: 10,
loop: true,                     
loopAdditionalSlides: 3,        
loopFillGroupWithBlank: true,
loop: true,             
    autoplay: {
            delay: 2500,          
            disableOnInteraction: false, 
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        767: {
            slidesPerView: 1.2,
        },
        992: {
            slidesPerView: 2,
        },
    },
});

var swiper = new Swiper(".journal_wrapper", {
slidesPerView: 4,
spaceBetween: 10,
loop: true,                     
loopAdditionalSlides: 4,        
loopFillGroupWithBlank: true,
loop: true,             
    autoplay: {
        delay: 2500000,          
        disableOnInteraction: true, 
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        767: {
            slidesPerView: 1.2,
                autoplay: {
                delay: 2500,          
                disableOnInteraction: false, 
            },
        },
        992: {
            slidesPerView: 2,
                autoplay: {
                delay: 2500,         
                disableOnInteraction: false, 
            },
        },
    },
});

var swiper = new Swiper(".wellness_wrapper", {
slidesPerView: 5,
spaceBetween: 10,
loop: true,                     
loopAdditionalSlides: 2,        
loopFillGroupWithBlank: true,
loop: true,             
    autoplay: {
        delay: 2500000,          
        disableOnInteraction: true, 
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        767: {
            slidesPerView: 1.2,
                autoplay: {
                delay: 2500,          
                disableOnInteraction: false, 
            },
        },
        992: {
            slidesPerView: 2,
                autoplay: {
                delay: 2500,         
                disableOnInteraction: false, 
            },
        },
    },
});

// ================== Faq js Start =========================

const faqItems = document.querySelectorAll(".faq-item");

faqItems.forEach(item => {
    const question = item.querySelector(".faq-question");

    question.addEventListener("click", () => {
        // pehle sabko close karo
        faqItems.forEach(i => {
        if (i !== item) {
            i.classList.remove("active");
            i.querySelector(".faq-icon").textContent = "+";
        }
        });

        // ab clicked item toggle karo
        item.classList.toggle("active");
        const icon = item.querySelector(".faq-icon");
        icon.textContent = item.classList.contains("active") ? "−" : "+";
    });
});

// ================== Faq js End =========================
